import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { MODEL_CONTEXT_UNREGISTERED_EXIT, TABS_UNREGISTERED_EXITS } from '../Model/Model';
import { useUnregisteredExitContextProvider } from './UnregisteredExitContextProvider';
import { MODELS } from '../../../../Apis/Models';
import { TABLES } from '../../../../Apis/Tables';
import { permissionObj } from '../../../../Helpers/permission';

const UnregisteredExitsApp = () => {
    const location = useLocation();
    let { state } = location;
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [steps, setSteps] = useState([]);
    const currentTab = state?.currentTab;
    const { paramsContext, setParamsContext } = useUnregisteredExitContextProvider();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    // Both tabs are exported from the same button, so the export is one permission for the screen
    const canExport = DEV || permission?.includes(permissionObj?.WEB_UNREGISTERED_EXITS_EXPORT);
    const [filterDialogShow, setFilterDialogShow] = useState(false);
    const [finalArray, setFinalArray] = useState([]);
    const [supplierId, setSupplierId] = useState(sessionStorage.getItem('providerId'));
    const [contractorId, setContractorId] = useState(sessionStorage.getItem('contractorId'));
    const [searchElement, setSearchElement] = useState('');
    const [search, setSearch] = useState(false);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const [criteria, setCriteria] = useState();
    const [activeStep, setActiveStep] = useState(0);
    const [modified, setModified] = useState(false);
    const [option, setOption] = useState(TABLES.CONTRACTOR_EMPLOYEE_ACCESS_LOG);
    const [moduleId, setModuleId] = useState(`${MODELS.CONTRACTOR_EMPLOYEE_ACCESS_LOG}`);
    const [detailsModal, setDetailsModal] = useState(false)
    const [checkOutModal, setCheckOutModal] = useState(false)
    const [itemSelected, setItemSelected] = useState(null)
    const [searchResults, setSearchResults] = useState('');
    const [bodyForExport, setBodyForExport] = useState('');
    const tabInitialized = useRef(false);

    useLayoutEffect(() => {
        if (!paramsContext) {
            setParamsContext({ ...MODEL_CONTEXT_UNREGISTERED_EXIT });
        }
    }, []);

    useLayoutEffect(() => {
        let activeTab = null;

        const stepConfig = [
            { tab: TABS_UNREGISTERED_EXITS.CONTRACTORS.TRANS, index: TABS_UNREGISTERED_EXITS.CONTRACTORS.INDEX },
            { tab: TABS_UNREGISTERED_EXITS.EQUIPMENT_AND_MATERIAL.TRANS, index: TABS_UNREGISTERED_EXITS.EQUIPMENT_AND_MATERIAL.INDEX },
        ];

        const auxStep = stepConfig.reduce((acc, { tab, index }) => {
            acc.push({
                label: t(tab),
                index,
            });

            if (activeTab === null) {
                activeTab = index;
            }

            return acc;
        }, []);

        setSteps(auxStep);

        // Only on the first run: later runs come from a language change, which just relabels the steps.
        // Calling handleStepChange again would run cleanSimpleSearch and wipe the loaded table.
        if (!tabInitialized.current && activeTab !== null && !paramsContext?.tabIndex && !currentTab) {
            tabInitialized.current = true;
            handleStepChange(activeTab);
        }
    }, [t]);

    useEffect(() => {
        if (paramsContext?.tabIndex !== null && typeof paramsContext?.tabIndex !== 'undefined') {
            handleStepChange(paramsContext?.tabIndex);
        }
    }, []);

    useLayoutEffect(() => {
        if (currentTab) handleStepChange(currentTab);
    }, [location]);

    /**
     * Closes the check-out modal together with the details modal it is opened from.
     */
    const closeModals = () => {
        setCheckOutModal(false);
        setDetailsModal(false);
        setItemSelected(null);
    };

    /**
     * Clears the simple search state so the key typed in one tab is not carried over to the other one.
     */
    const cleanSimpleSearch = () => {
        setSearchElement('');
        setSearchResults('');
        setBodyForExport('');
        setSimpleSearch(false);
    };

    /**
     * Points the advanced search and the export at the tab being shown: each tab is its own module, so
     * the filters it offers and the columns it exports come from that module, not from the other one.
     */
    const changeModuleAndOption = (step) => {
        if (step === TABS_UNREGISTERED_EXITS.CONTRACTORS.INDEX) {
            setModuleId(`${MODELS.CONTRACTOR_EMPLOYEE_ACCESS_LOG}`);
            setOption(TABLES.CONTRACTOR_EMPLOYEE_ACCESS_LOG);
        } else {
            setModuleId(`${MODELS.EQUIPMENT_INSIDE}`);
            setOption(TABLES.EQUIPMENT_INSIDE);
        }
    };

    const handleStepChange = (step) => {
        setActiveStep(step);
        cleanSimpleSearch();
        changeModuleAndOption(step);
        // The filters of one tab do not exist in the other one, so they are dropped when the tab changes
        setFinalArray([]);
        setSearch(false);
        setCriteria(null);
        if (setParamsContext)
            setParamsContext((prev) => ({
                ...prev,
                tabIndex: step,
            }));
    };

    return {
        t,
        finalArray,
        setFilterDialogShow,
        steps,
        activeStep,
        setActiveStep,
        handleStepChange,
        supplierId,
        searchElement,
        setSearch,
        contractorId,
        setSimpleSearch,
        search,
        setSearchElement,
        setCriteria,
        filterDialogShow,
        setFinalArray,
        moduleId,
        option,
        criteria,
        modified,
        setModified,
        bodyForExport,
        setBodyForExport,
        searchResults,
        setSearchResults,
        detailsModal,
        setDetailsModal,
        checkOutModal,
        setCheckOutModal,
        closeModals,
        itemSelected,
        setItemSelected,
        canExport
    };
};

export default UnregisteredExitsApp;
